import {Component, Input} from '@angular/core';
import {EmployeeEventResponseSummary} from "../../../company/_models/employee/employee-event-response-summary";
import {DatePipe, NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'ep-next-shift-item',
  imports: [
    DatePipe,
    NgIf,
    NgClass
  ],
  templateUrl: './next-shift-item.component.html',
  styleUrl: './next-shift-item.component.scss'
})
export class NextShiftItemComponent {
  @Input() shift!: EmployeeEventResponseSummary;
  @Input() showHeader: boolean = true;
  @Input() wide: boolean = false;
}
